module.exports = __webpack_public_path__ + "img/ardealul.5ce7ac5b.png";